const MIN_OFFSET_FROM_TOP_VIEWPORT = 35; // account for height of the fixed breadcrumbs bar or drawer header when used in WbDrawer

export const updateSidebarPosition = ({
  dom,
  sidebarElement,
  isMobile,
}: {
  dom: HTMLElement;
  sidebarElement: HTMLElement;
  isMobile: boolean;
}) => {
  // set sidebar position to render in correct position
  if (isMobile) {
    sidebarElement.style.top = '0px';
  } else {
    const page = document?.querySelector('.techdocs-reader-page');
    const pageTop = page?.getBoundingClientRect().top ?? 0;
    let domTop = dom.getBoundingClientRect().top ?? 0;

    const tabs = dom.querySelector('.md-container > .md-tabs');
    const tabsHeight = tabs?.getBoundingClientRect().height ?? 0;

    // the sidebars should not scroll beyond the total height of the header and tabs
    if (domTop < pageTop) {
      domTop = pageTop;
    }

    const scrollbarTopPx =
      Math.max(domTop, MIN_OFFSET_FROM_TOP_VIEWPORT) + tabsHeight;

    // set scrollbar height to ensure all links can be seen when content is small
    const footer = dom.querySelector('.md-container > .md-footer');
    // if no footer, fallback to using the bottom of the window
    const scrollbarEndPx =
      footer?.getBoundingClientRect().top ?? window.innerHeight;

    sidebarElement.style.top = `${scrollbarTopPx}px`;
    sidebarElement.style.height = `${scrollbarEndPx - scrollbarTopPx}px`;
  }

  // show the sidebar only after updating its position
  sidebarElement.style.setProperty('opacity', '1');
};
